import { withTranslations } from '@/utils/Language';
import suggestEditsEn from '@/assets/i18n/suggestEdits/en.json';
import uiEn from '@/assets/i18n/ui/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...suggestEditsEn, ...uiEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/suggestEdits/${lang}.json`),
      import(`@/assets/i18n/ui/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([suggestEdits, ui, languages, languagesTranslated]) => ({
      ...suggestEdits.default,
      ...ui.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
